export const LEARN_ASSISTANT_QUESTION_MAX_LENGTH = 300

export type LearnAssistantErrorKind = 'rate_limited' | 'network' | 'server' | 'unknown'

export function prepareLearnAssistantQuestion(question: string): {
  question: string
  questionLength: number
} {
  const trimmed = question.trim()
  return {
    question: trimmed.slice(0, LEARN_ASSISTANT_QUESTION_MAX_LENGTH),
    questionLength: trimmed.length,
  }
}

export function getLearnAssistantErrorKind(error: unknown): LearnAssistantErrorKind {
  if (!(error instanceof Error) || !('code' in error) || typeof error.code !== 'string') return 'unknown'
  if (error.code === 'RATE_LIMITED') return 'rate_limited'
  if (error.code === 'NETWORK') return 'network'
  return 'server'
}
